module.exports = __webpack_public_path__ + "static/media/aasu (3).725ebbba.png";